import './modalError.scss';

import Cancel from '../../../assets/images/icons/cancel.png';
import BTC from '../../../assets/images/icons/btcSad.png';

import React from "react";
import { Button } from '../button/button';

export const ModalError : React.FC = () => {

    return (
        <div className="modal-error-wrapper">
            <div className="modal-error">
                <img src={Cancel} alt="" className='cancel' />

                <img src={BTC} alt="" className='BTC'/>
                <p>
                    Erro ao realizar a transfẽrencia, por favor adicione mais saldo ou verifique o saldo da sua conta.
                </p>

                <Button label={'Tentar Novamente'} onClick={ () => console.dir('oi') } less={'less'}/>
            </div>
        </div>
    )
}